import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { MyPublicProfileModel } from "@dana/Services/DanaMyPublicProfileService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import updateMyPublicProfile from "@dana/Store/Data/MyPublicProfile/Handlers/UpdateMyPublicProfileHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonIconPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

export interface PublicProfileStyle {
    publicProfileMainContainer?: GridContainerProps;
    publicProfileMainWrapper?: GridItemProps;
    publicProfileHeading?: TypographyPresentationProps;
    publicProfileDescription?: TypographyPresentationProps;
    publicProfileFieldWrapper?: InjectableCss;
    publicProfileFieldGridItem?: GridItemProps;
    whereToBuyEmail?: TextFieldProps;
    publiProfilePhone?: TextFieldProps;
    publicProfileWebsite?: TextFieldProps;
    storeDescriptionTextArea?: TextAreaProps;
    publicProfileButtonWrapper?: GridItemProps;
    requiredInfoText?: TypographyPresentationProps;
    publicProfileSaveButton?: ButtonIconPresentationProps;
}

export const publicProfileStyle: PublicProfileStyle = {
    publicProfileHeading: {
        variant: "h3",
        color: themeBackgrounds.darkGray,
        css: css`
            width: 100%;
            margin: 0px;
            padding: 16px 0px;
            border-bottom: 1px solid ${themeBackgrounds.lightGray};
        `,
    },

    publicProfileDescription: {
        color: themeBackgrounds.darkGray,
    },
    publicProfileMainContainer: {
        offsetCss: css`
            background: ${themeBackgrounds.white};
            padding: 16px;
        `,

        css: css`
            padding: 16px;
        `,
    },

    publicProfileMainWrapper: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
            gap: 20px;
        `,
    },

    publicProfileFieldWrapper: {
        css: css`
            width: 100%;
        `,
    },
    publicProfileFieldGridItem: {
        width: [12, 12, 7, 8, 7],

        css: css`
            display: flex;
            flex-direction: column;
           
            .public-profile-save-btn {
                width: 100%;
                padding: 15px 0px;
                align-items: end;
                gap: 8px;
            }

        `,
    },

    whereToBuyEmail: {
        labelProps: {
            css: css`
                display: flex;
                min-height: 22px;
                width: 50%;
                color: ${themeBackgrounds.darkGray};

                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                           justify-content: end;
                        `,
                        css`
                            justify-content: end;
                        `,
                    ])}
            `,
        },
        cssOverrides: {
            formField: css`
                flex-direction: row;
                width: 100%;
                align-items: flex-start;
                gap: 20px;
                margin-top: 16px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: row;
                        `,
                        css`
                            flex-direction: row;
                        `,
                    ])}
            `,
            formInputWrapper: css`
                margin-top: 0px !important;
            `,
        },
    },
    publiProfilePhone: {
        cssOverrides: {
            formField: css`
                flex-direction: row;
                margin-top: 16px;
                width: 100%;
                align-items: flex-start;
                gap: 20px;

                  ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: row;
                        `,
                        css`
                            flex-direction: row;
                        `,
                    ])}
            `,
            formInputWrapper: css`
                margin-top: 0px !important;
            `,
        },
        labelProps: {
            css: css`
                display: flex;
                min-height: 22px;
                width: 50%;
                color: ${themeBackgrounds.darkGray};

                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                           justify-content: end;
                        `,
                        css`
                            justify-content: end;
                        `,
                    ])}
            `,
        },
        css: css``,
    },

    publicProfileWebsite: {
        cssOverrides: {
            formField: css`
                flex-direction: row;
                margin-top: 16px;
                width: 100%;
                align-items: flex-start;
                gap: 20px;

                  ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: row;
                        `,
                        css`
                            flex-direction: row;
                        `,
                    ])}
            `,
            formInputWrapper: css`
                margin-top: 0px !important;
            `,
        },
        labelProps: {
            css: css`
                display: flex;
                min-height: 22px;
                width: 50%;
                color: ${themeBackgrounds.darkGray};

                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                           justify-content: end;
                        `,
                        css`
                            justify-content: end;
                        `,
                    ])}
            `,
        },
        css: css``,
    },
    storeDescriptionTextArea: {
        cssOverrides: {
            formField: css`
                flex-direction: row;
                margin-top: 16px;
                width: 100%;
                align-items: flex-start;
                gap: 20px;

                  ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: column;
                        `,
                        css`
                            flex-direction: row;
                        `,
                        css`
                            flex-direction: row;
                        `,
                    ])}
            `,
            formInputWrapper: css`
                margin-top: 0px !important;
            `,
        },
        labelProps: {
            css: css`
                display: flex;
                min-height: 22px;
                width: 50%;
                color: ${themeBackgrounds.darkGray};

                 ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                           justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                            justify-content: start;
                        `,
                        css`
                           justify-content: end;
                        `,
                        css`
                            justify-content: end;
                        `,
                    ])}
            `,
        },
    },
    publicProfileButtonWrapper: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    publicProfileSaveButton: {
        css: css``,
    },
    requiredInfoText: {
        color: themeBackgrounds.darkGray,
        css: css`
            font-style: italic;
        `,
    },
};

const styles = publicProfileStyle;


const mapStateToProps = (state: ApplicationStateDana) => {

    const myPublicProfile = state.myPublicProfileState.myPublicProfile;
    const session = getSession(state);
    const { shipToId, properties } = session;
    const shipToState = getShipToState(state, shipToId);
    const { value: shipTo } = shipToState;

    const soldAdrr = (properties?.soldToAddress && properties?.soldToAddress !== "" && properties?.soldToAddress !== undefined) ? JSON.parse(properties?.soldToAddress) : null;
    const selectedCustomer = soldAdrr != null && soldAdrr?.id ? soldAdrr : shipTo;

    return {
        session,
        myPublicProfileData: myPublicProfile,
        customer: selectedCustomer
    };
};

const mapDispatchToProps = {
    updateMyPublicProfile
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const MyPublicProfile: React.FC<Props> = ({ myPublicProfileData, updateMyPublicProfile, session, customer }) => {
    const [whereToBuyEmail, setWhereToBuyEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [website, setWebsite] = useState("");
    const [storeDescription, setStoreDescription] = useState("");
    const toasterContext = useContext(ToasterContext);
    useEffect(() => {
        setWhereToBuyEmail(myPublicProfileData?.wtbMapEmail);
        setPhone(myPublicProfileData?.phone);
        setWebsite(myPublicProfileData?.websiteUrl);
        setStoreDescription(myPublicProfileData?.storeDescription);

    }, [myPublicProfileData]);

    const updateMyPublicProfileHandler = () => {
        updateMyPublicProfile({
            userName: session?.userName,
            customerId: customer?.id,
            wtbMapEmail: whereToBuyEmail,
            phone,
            storeDescription,
            websiteUrl: website,
            onSuccess: (response: MyPublicProfileModel) => {

                toasterContext.addToast({
                    body: translate("Profile Updated Successfully."),
                    messageType: "success",
                    isFocusAfterMount: true,
                });
            },
            onError: (error: any) => {

                toasterContext.addToast({
                    body: error ?? translate("Something went wrong, Please try again later."),
                    messageType: "danger",
                    isFocusAfterMount: true,
                });
            },
            onComplete(resultProps: any) {
                console.log("resultProps=>", resultProps)
            },
        } as any);

    }
    return (
        <GridContainer {...styles.publicProfileMainContainer}>
            <GridItem width={12} {...styles.publicProfileMainWrapper}>
                <Typography {...styles.publicProfileHeading}>{translate("My Public Profile")}</Typography>
                <Typography as="p" {...styles.publicProfileDescription}>
                    {translate(
                        "The information below is required and will be reflected in the 'Where to Buy' section on this site. Email address will be used to send notification of receiving a request for quote."
                    )}
                </Typography>
            </GridItem>
            <StyledWrapper {...styles.publicProfileFieldWrapper}>
                <GridItem {...styles.publicProfileFieldGridItem}>
                    <TextField
                        label={translate("Where to Buy Map Email")}
                        type="email"
                        value={whereToBuyEmail}
                        onChange={(e) => setWhereToBuyEmail(e.target.value)}
                        {...styles.whereToBuyEmail}
                    />
                    <TextField
                        label={translate("Phone(mobile)")}
                        name="phone"
                        min={10}
                        maxLength={256}
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        {...styles.publiProfilePhone}
                    />
                    <TextField
                        label={translate("Website")}
                        type="text"
                        value={website}
                        onChange={(e) => setWebsite(e.target.value)}
                        {...styles.publicProfileWebsite}
                    />
                    <TextArea
                        label={translate("Store Description")}
                        value={storeDescription}
                        onChange={(e) => setStoreDescription(e.target.value)}
                        {...styles.storeDescriptionTextArea}
                    />
                    <GridItem {...styles.publicProfileButtonWrapper} className="public-profile-save-btn">
                        <Button onClick={updateMyPublicProfileHandler} type="submit" {...styles.publicProfileSaveButton}>
                            {translate("Save Changes")}
                        </Button>

                    </GridItem>
                </GridItem>
            </StyledWrapper>
        </GridContainer>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(MyPublicProfile);
